import { useEffect, useRef, useState } from "react";
import { motion, useInView, animate } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, lineClassName = "", delay = 0, onLoad = false }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const show = onLoad || inView;
  return (
    <span ref={ref}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "112%" }}
            animate={show ? { y: "0%" } : { y: "112%" }}
            transition={{ duration: 1.1, delay: delay + i * 0.14, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

export const Eyebrow = ({ children }) => (
  <span className="flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.3em] text-emerald-500">
    <span className="h-px w-8 bg-emerald-500/60" />
    {children}
  </span>
);

export const Counter = ({ to, suffix = "", className = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, {
      duration: 1.8,
      ease: EASE,
      onUpdate: (v) => setVal(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, to]);
  return (
    <span ref={ref} className={className}>
      {val}
      {suffix}
    </span>
  );
};

export const Marquee = ({ items, className = "" }) => (
  <div className={`overflow-hidden whitespace-nowrap ${className}`} data-testid="editorial-marquee">
    <div className="marquee-track inline-flex w-max items-center">
      {[...items, ...items, ...items, ...items].map((item, i) => (
        <span key={i} className="inline-flex items-center">
          <span className="px-8">{item}</span>
          <span className="inline-block h-1.5 w-1.5 rotate-45 bg-emerald-500/70" />
        </span>
      ))}
    </div>
  </div>
);
